module.exports = __webpack_public_path__ + "static/media/Upsell_Tab_Amazing@3x.7e1dfc53.png";